module.exports = __webpack_public_path__ + "static/fonts/Nunito-BlackItalic.0849e85.woff";